import { t } from "i18n";
import { OptionModel } from "model/Option.model";

export const initialOptionList = [new OptionModel("createUserFetchedSelectService.initialOptionTitle", t("createUserFetchedSelectService.initialOptionTitle"))];
